import { Radio, FormControlLabel, RadioGroup, Typography } from "@mui/material";
import { palette } from "../../../styles/theme";
import { Box } from "../../../common/components";
import { useTranslation } from "react-i18next";
import { FormattedPrice } from "../common/types";
import { ShippingTierForCurrency } from "../../../types";
import { sortByShippingOption } from "../../../utils/SortingUtils";
import { CalculatePriceModalStyles } from "../common/styles";
import HolidayWarning from "../../../components/HolidayWarning";

interface Props {
  shippingPrice: FormattedPrice;
  shippingOptions?: ShippingTierForCurrency[];
  selectedShippingOption: ShippingTierForCurrency | null;
  handleChangeShippingOption: (option: ShippingTierForCurrency) => void;
  quantity: number;
}

const ShippingSection = ({
  shippingOptions,
  shippingPrice,
  selectedShippingOption,
  handleChangeShippingOption,
  quantity,
}: Props) => {
  const { t } = useTranslation();
  const shouldHideDelayAndExpress = shippingOptions?.some(
    (option) => quantity >= option.hideDelayAfter
  );

  return (
    <>
      <Box sx={CalculatePriceModalStyles.bottomSection}>
        <Typography variant="textRegularBold">
          {t("pricing.shipping")}
        </Typography>
        <Typography variant="textRegularBold">
          {shippingPrice.formatted}
        </Typography>
      </Box>
      <HolidayWarning />
      <Box>
        <RadioGroup sx={{ gap: "12px" }}>
          {shippingOptions
            ?.sort(sortByShippingOption)
            .map((shippingOption, index) => {
              if (shouldHideDelayAndExpress && index > 0) return null;
              return (
                <FormControlLabel
                  key={index}
                  control={
                    <Radio
                      onChange={() =>
                        handleChangeShippingOption(shippingOption)
                      }
                      checked={
                        selectedShippingOption?.tier === shippingOption.tier
                      }
                    />
                  }
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "normal",
                      color: palette.grey.nearBlack,
                    },
                  }}
                  label={t(
                    shouldHideDelayAndExpress
                      ? "order.shipping_options_without_delay"
                      : `pricing.delivery_speed_options.${shippingOption.tier}`,
                    {
                      minWeeks: shippingOption.minWeeks,
                      maxWeeks: shippingOption.maxWeeks,
                      shippingTier: t(
                        `general.shipping_tier.${shippingOption.tier}`
                      ),
                    }
                  )}
                />
              );
            })}
        </RadioGroup>
      </Box>
    </>
  );
};

export default ShippingSection;
